import { Button, Dropdown, message } from "antd";
import type { MenuProps } from "antd";
import { FaFileExport, FaFilePdf, FaFileExcel } from "react-icons/fa";
import { useState } from "react";

import $axios from "../../api/accessor";
import { $api } from "../../api/api";

const ExportButtons = () => {
  const [loading, setLoading] = useState(false);

  const handleExportExcelAndPDF = async (type: "EXCEL" | "PDF") => {
    setLoading(true);
    try {
      const endpoint = type === "EXCEL" ? "export_excel" : "export_pdf";

      // responseType: 'blob' - file yükləmək üçün vacibdir
      const response = await $axios.get($api(endpoint), {
        responseType: "blob",
      });

      // Blob-dan file yaradırıq
      const blob = new Blob([response.data], {
        type:
          type === "EXCEL"
            ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            : "application/pdf",
      });

      // Download linki yaradırıq
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      // Fayl adı - tarix ilə
      const timestamp = new Date().toISOString().split("T")[0];
      link.download = `mehsullar_${timestamp}.${
        type === "EXCEL" ? "xlsx" : "pdf"
      }`;

      // Linki klikləyib faylı yükləyirik
      document.body.appendChild(link);
      link.click();

      // Təmizləmə
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      message.success(`${type === "EXCEL" ? "Excel" : "PDF"} uğurla yükləndi!`);
    } catch (error) {
      console.error("Export error:", error);
      message.error(
        `${type === "EXCEL" ? "Excel" : "PDF"} yüklənərkən xəta baş verdi!`
      );
    } finally {
      setLoading(false);
    }
  };

  const items: MenuProps["items"] = [
    {
      key: "pdf",
      label: "PDF olaraq yüklə",
      icon: <FaFilePdf size={16} color="#E53E3E" />,
      onClick: () => handleExportExcelAndPDF("PDF"),
      disabled: loading,
    },
    {
      key: "excel",
      label: "Excel olaraq yüklə",
      icon: <FaFileExcel size={16} color="#38A169" />,
      onClick: () => handleExportExcelAndPDF("EXCEL"),
      disabled: loading,
    },
  ];

  return (
    <Dropdown menu={{ items }} trigger={["click"]} placement="bottomRight">
      <Button
        type="primary"
        icon={<FaFileExport size={20} />}
        loading={loading}
        style={{
          backgroundColor: "#10B981",
          borderColor: "#10B981",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          padding: "14px 24px",
          height: "max-content",
        }}
      >
        Export
      </Button>
    </Dropdown>
  );
};

export default ExportButtons;
